// extracted by mini-css-extract-plugin
module.exports = {"root":"yZTtNqmZ","separator":"gjS3ThCY","button":"xUwv26Bk"};